import type { Site } from '../types/site';

export const UNASSIGNED_SITE_ID = '__no_site__';

export const UNASSIGNED_JOB_SITE: Site = {
  id: UNASSIGNED_SITE_ID,
  name: 'No site',
  location: '',
  tower: {
    id: UNASSIGNED_SITE_ID,
    height: 30,
    crossMemberWidth: 450,
    sectionHeight: 3,
    shape: 'square',
    mountingPoints: [],
    stayWires: [],
  },
  equipment: [],
  jobs: [],
  createdAt: new Date(0),
  updatedAt: new Date(0),
};

export const isUnassignedSiteId = (siteId: string | null | undefined): boolean =>
  !siteId || siteId === UNASSIGNED_SITE_ID;
